// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo-module--logo--JXusl","logo__image":"Logo-module--logo__image--1FYzf"};